import { render, staticRenderFns } from "./theoryManagement.vue?vue&type=template&id=193312c2&scoped=true"
import script from "./theoryManagement.vue?vue&type=script&lang=js"
export * from "./theoryManagement.vue?vue&type=script&lang=js"
import style0 from "./theoryManagement.vue?vue&type=style&index=0&id=193312c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193312c2",
  null
  
)

export default component.exports